const bem = (base, mods = [], block, extra = []) => {
  const classes = [block ? `${block}__${base}` : base];
  mods = mods
    .map(
      (item) =>
        item && (block ? `${block}__${base}--${item}` : `${base}--${item}`),
    )
    .filter((el) => el);
  return classes.concat(extra, mods).join(' ').trim();
};

export default bem;
